//import Swiper from 'swiper'
//import Swiper, { Navigation, Pagination } from 'swiper';

// Bring all modules.... navigation, pagination, thumbNails
import Swiper from 'swiper/bundle';


class MySwiper4 {
	constructor() {
		this._init()
	}
	_init() {
        
        this.el = document.querySelector('[product-thumb]')
		if(!this.el) {
			return
		}
        
        var galleryThumbs = new Swiper('.gallery-thumbs', {
            spaceBetween: 15,
            slidesPerView: 8, //Must be used on the posterior verification to allow mouse touch or not
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            allowTouchMove: false,
        });

        var galleryTop = new Swiper('.gallery-top', {
            spaceBetween: 0,
            pagination: {
                el: '.swiper-pagination',
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            thumbs: {
                swiper: galleryThumbs
            },
        });

        if(galleryThumbs.slides.length > 8){ //Must be the same as slides per view
            galleryThumbs.allowTouchMove = true;
        }
	}
}
export default MySwiper4